import React from 'react'
import Drawer from "react-drag-drawer";
import { BsX } from "react-icons/bs";
import LogoPng from '../../assets/images/new/dum-dum-logo.png'

const DownloadAppModal = (props) => {
  return (
    <Drawer
      direction="bottom"
      open={props.opened}
      dontApplyListeners={true}
      onRequestClose={props.close}
      containerElementClass="px-6"
    >
      <div className='w-full bg-white rounded-xl p-6 space-y-2 relative text-blue-primary text-center'>
        <button className='ml-6 bg-white border-0 absolute top-4 right-4' onClick={props.close}>
          <BsX className='w-8 h-8 text-blue-primary' />
        </button>

        <img src={LogoPng} className='w-40 h-12 mx-auto' alt='Logo' />
        <br />
        <br />

        <h1 className='text-xl font-black text-blue-primary'>Leve a magia dos contos infantis com você!</h1>
        <br />

        <p className='font-bold'>Conheça o app do DumDum Livros e transforme qualquer momento em uma oportunidade de imaginação e aprendizado!</p>

        <br />
        <p>Baixe os livros infantis e leia mesmo sem internet — ideal para viagens, esperas ou a hora de dormir.</p>
        <p>Ilustrações divertidas e textos feitos com carinho para os pequenos exploradores.</p>
        <p>Navegação simples e segura, pensada para pais e filhos aproveitarem juntos.</p>
        <p>Atualizações com novos contos direto no seu celular!</p>

        <p>Baixe agora o app e comece essa jornada literária com seu pequeno!</p>

        <br />
        <br />
        <a
          href='https://play.google.com/store/apps/details?id=br.com.gravioladigital.dumdum'
          target='_blank'
          className='cursor-pointer w-full lg:w-1/2 h-12 flex flex-row justify-center items-center rounded-full bg-yellow-primary text-blue-primary font-bold mx-auto'
        >
          Baixar para android
        </a>
        <br />
        <a
          href='https://apps.apple.com/br/app/dum-dum-livros/id6743821504'
          target='_blank'
          className='cursor-pointer w-full lg:w-1/2 h-12 flex flex-row justify-center items-center rounded-full bg-yellow-primary text-blue-primary font-bold mx-auto'
        >
          Baixar para iOS
        </a>
      </div>
    </Drawer>
  )
}

export default DownloadAppModal